import { t } from '@/i18n';
import { DateRangeSchema, DayjsSchema } from '@/utils';
import { z } from 'zod';
import {
  commentOrderingType,
  commentPublishType,
  commentReadStatusEnum,
} from './comment';

export const commentResolvedStatusType = z.enum([
  'all',
  'unresolved',
  'resolved',
]);
export const CommentResolvedStatusLabelModifier = {
  all: t('all'),
  unresolved: t('unresolved'),
  resolved: t('resolved'),
} as const satisfies Record<z.infer<typeof commentResolvedStatusType>, string>;

export const CommentSearchFormSchema = z.object({
  createdMonthRange: DateRangeSchema.nullable(),
  keyword: z.string().nullable(),
  resolvedStatus: commentResolvedStatusType,
  publishType: commentPublishType,
  readStatus: commentReadStatusEnum.nullable(),
  labelId: z.string().uuid().nullable(),
  tagIds: z.array(z.string().uuid()).nullable(),
  authorId: z.string().uuid().nullable(),
  assigneeId: z.string().uuid().nullable(),
  organizationIds: z.string().uuid().array().array(),
  pinpointKeys: z.string().array(),
  // 事業年度
  fiscalYear: DayjsSchema().nullable(),
});

const CommentFilterParamsSchema = z
  .object({
    publishType: commentPublishType.nullable(),
    readStatus: commentReadStatusEnum.nullable(),
    ordering: commentOrderingType,
    resolved: z.boolean().nullable(),
    pinpointKey: z.string().nullable(),
    labelId: z.string().uuid().nullable(),
    isCurrentActiveTabOnly: z.boolean().optional(),
  })
  .partial();

export type CommentFilterParams = z.infer<typeof CommentFilterParamsSchema>;
